import React from 'react';
import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';

import { useIntl } from 'ha/i18n';
import { Grid, Paper, Typography, units } from '@ha/dsl';

import SearchBar from './SearchBar';
import Picture from './Picture';

export const styles = (theme: Theme) =>
  createStyles({
    container: {
      [theme.breakpoints.down('sm')]: {
        backgroundColor: theme.palette.white.main,
      },
    },
    header: {
      color: theme.palette.primary.main,
      [`@supports (
          (background-clip: text) or (-webkit-background-clip: text)
        ) and (
          (text-fill-color: transparent) or (-webkit-text-fill-color: transparent)
        )`]: {
        background: 'linear-gradient(10deg, #FFA58D 0% 30%, #664B87 40% 100%);',
        '-webkit-background-clip': 'text',
        backgroundClip: 'text',
        textFillColor: 'transparent',
        // this prefix is not added on server side
        // https://github.com/cssinjs/jss/issues/279
        WebkitTextFillColor: 'transparent',
        [theme.breakpoints.up('md')]: {
          background:
            'linear-gradient(10deg, #FFA58D 0% 20%, #664B87 40% 100%);',
          '-webkit-background-clip': 'text',
          backgroundClip: 'text',
          textFillColor: 'transparent',
          WebkitTextFillColor: 'transparent',
        },
        fallbacks: {
          background: theme.palette.primary.main,
        },
      },
      fontSize: units.rem(1.75),
      textAlign: 'center',
      margin: '0',
      padding: units.yx(2, 3),
      [theme.breakpoints.up('md')]: {
        fontSize: units.rem(3.25),
        lineHeight: units.rem(3.375),
        paddingTop: units.rem(3.875),
        paddingBottom: units.rem(1),
        maxWidth: units.rem(49),
      },
    },
    searchBarContainer: {
      position: 'relative',
    },
    searchBar: {
      margin: units.txb(0, 0.5, 4),
      padding: units.rem(0.5),
      [theme.breakpoints.up('md')]: {
        margin: units.txb(4, 1, 12),
        maxWidth: units.rem(70),
      },
      zIndex: 1,
    },
    paper: {
      borderRadius: 10,
    },
  });

export const Hero: React.FC<WithStyles<typeof styles>> = ({ classes }) => {
  const { T } = useIntl();

  return (
    <div className={classes.container}>
      <Grid container justify="center">
        <Typography.H1
          align="center"
          className={classes.header}
          data-test-locator="Home Hero Title"
        >
          {T('Safely book your new home abroad')}
        </Typography.H1>
      </Grid>
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.searchBarContainer}
      >
        <Picture />
        <Grid item xs={12} className={classes.searchBar}>
          <Paper classes={{ root: classes.paper }}>
            <SearchBar />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(Hero);
